/**
 * Coup de pouce — Attendu 1106 « priorités opératoires : 1 + 3 × 8 »
 * (automatisme 4e, l. 700). DEUX pages STATIQUES aux mêmes nombres,
 * partagées par les trois generator_keys : « Sans parenthèses » 1 + 3 × 8 =
 * 25 et « Avec parenthèses » (1 + 3) × 8 = 32. Chaque page nomme l'autre
 * résultat : c'est la différence entre les deux qui est l'automatisme
 * (l'erreur principale, lire de gauche à droite, donne 32 pour 1 + 3 × 8).
 *
 * L'image que l'élève a déjà : le cadre orange autour de ce qu'on calcule
 * d'abord (5e, 1041), puis les lignes qui s'alignent sous le signe égal.
 * Page 1 : le cadre sur 3 × 8, « = 1 + 24 », « = 25 » ; une ligne : « Sans
 * parenthèses, la multiplication passe avant. » et le piège nommé : « Pas
 * 4 × 8 = 32 : ça, c'est (1 + 3) × 8. » Page 2 : le cadre sur (1 + 3),
 * « = 4 × 8 », « = 32 » ; « Les parenthèses passent avant tout. » et
 * « Sans les parenthèses, 1 + 3 × 8 = 25. »
 *
 * SACRIFIÉ : le triplet (1 ; 3 ; 8) sous toutes ses formes (gen_1106,
 * TRIPLET_SACRIFIE, auto-testé par gen1106.self.test.js). Largeur bornée à
 * 340 px, tailles de 1048.
 */

const ORANGE = '#EA580C';
const ORANGE_CLAIR = '#FED7AA';
const BLEU = '#2563EB';
const ENCRE = '#1E293B';

/** Une page : l'expression avec son cadre « d'abord », les deux lignes du calcul, le résultat, deux phrases. */
const page = ({ aria, expression, cadre, ligne2, resultat, phrases }) => `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 236" width="100%" style="max-width:340px;height:auto;display:block" role="img"
     aria-label="${aria}">
  <!-- le cadre orange : ce qu'on calcule d'abord -->
  <rect x="${cadre.x}" y="46" width="${cadre.w}" height="34" rx="8" fill="${ORANGE_CLAIR}" stroke="${ORANGE}" stroke-width="2"/>
  <text x="${cadre.x + cadre.w / 2}" y="38" font-size="11" font-weight="bold" text-anchor="middle" fill="${ORANGE}">d'abord</text>
  <text x="${cadre.x + cadre.w / 2}" y="102" font-size="12" font-weight="bold" text-anchor="middle" fill="${ORANGE}">${cadre.vaut}</text>
  <text x="200" y="70" font-size="22" font-weight="bold" text-anchor="middle" fill="${ENCRE}">${expression}</text>
  <text x="200" y="136" font-size="20" font-weight="bold" text-anchor="middle" fill="${ENCRE}">${ligne2}</text>
  <text x="200" y="168" font-size="20" font-weight="bold" text-anchor="middle" fill="${ENCRE}">= <tspan fill="${BLEU}">${resultat}</tspan></text>

  <!-- le geste, puis l'autre résultat -->
  <text x="200" y="204" font-size="12" text-anchor="middle" fill="${ENCRE}">${phrases[0]}</text>
  <text x="200" y="226" font-size="12" text-anchor="middle" fill="${ENCRE}">${phrases[1]}</text>
</svg>`.trim();

const SVG_SANS = page({
    aria: '1 plus 3 fois 8. Un cadre orange entoure 3 fois 8, marqué d\'abord : ça vaut 24. Dessous : égale 1 plus 24, égale 25. Sans parenthèses, la multiplication passe avant. Pas 4 fois 8 égale 32 : ça, c\'est 1 plus 3 entre parenthèses, fois 8.',
    expression: `1 + <tspan fill="${ORANGE}">3 × 8</tspan>`,
    cadre: { x: 186, w: 84, vaut: '= 24' },
    ligne2: `= 1 + <tspan fill="${ORANGE}">24</tspan>`,
    resultat: 25,
    phrases: [
        'Sans parenthèses, la multiplication passe avant.',
        `Pas 4 × 8 = 32 : ça, c'est <tspan font-weight="bold">(1 + 3) × 8</tspan>.`,
    ],
});

const SVG_AVEC = page({
    aria: '1 plus 3, entre parenthèses, fois 8. Un cadre orange entoure la parenthèse 1 plus 3, marqué d\'abord : ça vaut 4. Dessous : égale 4 fois 8, égale 32. Les parenthèses passent avant tout. Sans les parenthèses, 1 plus 3 fois 8 égale 25.',
    expression: `<tspan fill="${ORANGE}">(1 + 3)</tspan> × 8`,
    cadre: { x: 122, w: 100, vaut: '= 4' },
    ligne2: `= <tspan fill="${ORANGE}">4</tspan> × 8`,
    resultat: 32,
    phrases: [
        'Les parenthèses passent avant tout.',
        `Sans les parenthèses, <tspan font-weight="bold">1 + 3 × 8</tspan> = 25.`,
    ],
});

const AIDE = {
    pages: [
        { titre: 'Sans parenthèses', svg: SVG_SANS },
        { titre: 'Avec parenthèses', svg: SVG_AVEC },
    ],
};

const CP_1106 = {
    flash_texte_trou_saisie: AIDE,
    resultat_qcm_unique: AIDE,
    sens_tableau_vf: AIDE,
};

export default CP_1106;
